import React, { useEffect, useState } from 'react';
import axios from 'axios';
import MainURL from '../MainURL';
import { format } from "date-fns";
import { useNavigate } from 'react-router-dom';
import './MainPopup.scss';

interface PopupProps {
  id: number;
  title: string;
  image: string;
  content: string;
  link: string;
}

// '오늘 하루 보지 않기' 저장 키
const hideKey = (id: number) => `popupHide_${id}`;
const today = () => format(new Date(), 'yyyy-MM-dd');

const isHiddenToday = (id: number) => {
  try {
    return localStorage.getItem(hideKey(id)) === today();
  } catch {
    return false;
  }
};

export default function MainPopup() {
  const navigate = useNavigate();
  const [popups, setPopups] = useState<PopupProps[]>([]);

  const fetchPopups = async () => {
    try {
      const res = await axios.get(`${MainURL}/main/getpopups`);
      if (Array.isArray(res.data)) {
        setPopups(res.data.filter((item: PopupProps) => !isHiddenToday(item.id)));
      }
    } catch (e) {
      console.error('팝업 로드 오류:', e);
    }
  };

  useEffect(() => {
    fetchPopups();
  }, []);

  const close = (id: number) => {
    setPopups(prev => prev.filter(item => item.id !== id));
  };

  const hideToday = (id: number) => {
    try {
      localStorage.setItem(hideKey(id), today());
    } catch {}
    close(id);
  };

  const openLink = (link: string) => {
    if (!link) return;
    if (link.startsWith('/')) {
      navigate(link);
    } else {
      window.open(link.startsWith('http') ? link : `https://${link}`, '_blank');
    }
  };

  if (popups.length === 0) return null;

  return (
    <div className="main_popup_overlay">
      <div className="main_popup_list">
        {popups.map((item) => (
          <div className="main_popup" key={item.id}>
            <div className={`main_popup_body ${item.link ? 'clickable' : ''}`} onClick={() => openLink(item.link)}>
              {item.image && (
                <img src={`${MainURL}/images/popup/${item.image}`} alt={item.title || '팝업'} />
              )}
              {(item.title || item.content) && (
                <div className="main_popup_text">
                  {item.title && <h3>{item.title}</h3>}
                  {item.content && <p>{item.content}</p>}
                </div>
              )}
            </div>
            <div className="main_popup_footer">
              <div onClick={() => hideToday(item.id)}>오늘 하루 보지 않기</div>
              <div onClick={() => close(item.id)}>닫기</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
